import { render } from "./Meigaranewsrecentl_lazy.vue?vue&type=template&id=3c748678&scoped=true"
import script from "./Meigaranewsrecentl_lazy.vue?vue&type=script&lang=js"
export * from "./Meigaranewsrecentl_lazy.vue?vue&type=script&lang=js"

import "./Meigaranewsrecentl_lazy.vue?vue&type=style&index=0&id=3c748678&scoped=true&lang=scss"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c748678"]])

export default __exports__